module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/more-topic-1.2d957d47.jpg";